<script>
import { debounce } from '@/helpers/debounce'
import McButton from '@/components/McButton'
import Multiselect from 'vue-multiselect'
import { Helper } from '@/mixin/helper'

export default {
  components: {
    McButton,
    Multiselect,
  },
  mixins: [Helper],
  props: {
    fields: { required: true },
    apiClient: { required: true },
    trackBy: { default: 'id' },
    limitOptions: {
      default: () => [10, 25, 50, 100],
    },
    hasDelete: {
      type: Boolean,
      default: true,
    },
    bulkDeleteApi: {
      type: Boolean,
      default: false,
    },
    refreshData: {
      type: Boolean,
      default: false,
    },
    customHandlers: {
      type: Object,
    },
    searchable: {
      type: Boolean,
    },
    busy: {
      type: Boolean,
    },
    withCard: {
      type: Boolean,
    },
    hasCheckbox: {
      type: Boolean,
      default: true,
    },
    hasSelectAll: {
      type: Boolean,
      default: true,
    },
    stickyHeader: {
      type: Boolean,
    },
    isSelectableField: {
      type: Boolean,
    },
    hasStore: {
      type: Object,
    },
    checkType: {
      type: String,
      default: 'multiple',
    },
    hasDisabled: {
      default: false,
    },
    showPagination: { type: Boolean, default: true },
    stickyCheckbox: {
      type: Boolean,
      default: true,
    },
    hasBorder: {
      default: false,
    },
    customButton: {
      type: Boolean,
    },
    hasMassSelect: {
      default: false,
    },
    isTextWrap: {
      default: false,
      type: Boolean,
    },
    activeFilters: {
      type: Object,
    },
    hasFilter: {
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    cardPadding: {
      type: Boolean,
      default: true,
    },
    isEmpty: {
      type: Boolean,
      default: false,
    },
    hasBilingual: {
      type: Boolean,
      default: false,
    },
    lazyLoadAddress: {
      type: Boolean,
      default: false,
    },
    reportKey: {
      type: String,
      default: '',
    },
    customToast: { type: Function },
    displayDeleteBy: {
      type: String,
      default: '',
    },
    customDelete: {
      type: Boolean,
      default: false,
    },
    emptyButton: {
      type: Boolean,
      default: false,
    },
    filterBottom: {
      type: Boolean,
      default: false,
    },
    itemProperty: {
      type: String,
      default: '',
    },
    singleSort: {
      type: Boolean,
      default: false,
    },
    hasGraph: {
      type: Boolean,
      default: false,
    },
    initialSelectedIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show_model: [],
      page: 1,
      limit: 10,
      totalCount: 0,
      isBusy: true,
      search: '',
      sorts: [],
      items: [],
      ids: [],
      rowUpdate: {},
      selectedIds: {},
      selectedIdsLength: 0,
      selectedAll: false,
      dataFields: this.cloneFields(this.fields),
      dataColumns: this.cloneColumns(this.fields),
      selectedName: null,
      selectedNames: {},
      isTable: true,
      dataGraph: {},
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale
    },
    startData() {
      return this.limit * this.page - this.limit + 1
    },
    endData() {
      const _endData = this.limit * this.page
      return this.totalCount < _endData ? this.totalCount : _endData
    },
    showedFields() {
      return [...this.fields]
    },
    computedFields() {
      const fields = this.dataFields?.filter((field) => field.shown)

      if (this.hasCheckbox) {
        if (!fields.find((item) => item.key == 'checkbox')) {
          fields.unshift({
            key: 'checkbox',
            label: '',
            stickyColumn: this.stickyCheckbox,
          })
        }
      }
      if (this.show_model && this.show_model.length > 0) {
        let result = this.show_model.map((a) => a.key)

        return fields.filter(function (item) {
          return item.key == 'checkbox' || result.includes(item.key)
        })
      } else {
        return fields
      }
    },
    initialFields() {
      return this.cloneFields(this.fields)
    },
    classTable() {
      const textWrap = !this.isTextWrap ? 'text-nowrap' : ''
      return `table-responsive ${textWrap} border border-1 mc-table-overflow`
    },
    address() {
      return this.$store.state.map.address
    },
    childFields() {
      const filteredData = this.fields.filter((obj) => {
        return Object.prototype.hasOwnProperty.call(obj, 'children')
      })

      return filteredData
    },
  },
  watch: {
    async locale() {
      this.dataFields = this.cloneFields(this.fields)

      if (this.hasBilingual) {
        await this.getData({
          limit: this.limit,
          page: this.page,
        })
      }
    },
    refreshData: {
      async handler(val) {
        if (val) {
          this.selectedIds = []
          this.selectedIdsLength = 0
          await this.getData({
            limit: this.limit,
            page: 1,
          })
        }
      },
      deep: true,
      immediate: true,
    },
    activeFilters() {
      this.getData({
        limit: this.limit,
        page: 1,
      })
    },
  },
  async mounted() {
    await this.$nextTick()
    await this.getData(
      {
        limit: this.limit,
        page: this.page,
      },
      true
    ).then(() => {
      if (this.initialSelectedIds) {
        this.initialSelectedIds.forEach((id) => {
          this.$set(this.selectedIds, id.toString(), true)
        })

        this.selectedIdsLength = Object.values(this.selectedIds).filter(Boolean).length

        if (this.hasSelectAll) {
          this.selectedAll = this.ids.every((id) => this.selectedIds[id.toString()])
        }
      }
    })
  },
  methods: {
    focusSearch() {
      this.$refs.searchInput.focus()
    },

    async generateAddressReport() {
      const finalFields = this.deepClone(this.fields, 'child')
      const column =
        this.reportKey != 'vehicle-offline'
          ? finalFields.map((field) => field.header)
          : finalFields.map((field) => field.key)
      const address = this.address
      const { data, newAddress } = await this.generateAddress(
        address,
        this.items,
        this.reportKey,
        column
      )
      newAddress.forEach((item) => {
        this.$store.commit('map/SET_ADDRESS_INFO', item)
      })
    },

    showDeleteModal() {
      this.$refs['mc-modal-delete'].show()
    },

    deepClone(fields, level) {
      const finalFields = []

      fields.forEach((field) => {
        if (level == 'parent') {
          finalFields.push(field)
        } else {
          if (Object.prototype.hasOwnProperty.call(field, 'children')) {
            finalFields.push(...field.children)
          } else {
            finalFields.push(field)
          }
        }
      })
      return finalFields
    },

    cloneFields(fields) {
      const finalFields = this.deepClone(fields, 'child')
      finalFields.forEach((item) => {
        if (item.shown === undefined) item.shown = true
      })
      return finalFields
    },

    cloneColumns(fields) {
      const finalFields = this.deepClone(fields, 'parent')
      finalFields.forEach((item) => {
        if (item.shown === undefined) item.shown = true
      })
      return finalFields
    },

    stringSorts() {
      const arr = this.sorts.map((sort) => {
        const obj = {
          [sort.key]: sort.order,
        }
        return JSON.stringify(obj)
      })

      return arr
    },
    // TECHDEBT: Only supports resourceful format
    // getData methods can be improved to support user-supplied data
    async getData(opts, refresh = false) {
      if (!this.apiClient?.get) {
        this.isBusy = false
        return
      }

      const filter = {
        pagination: {
          page: opts.page,
          show: opts.limit,
        },
        orderBy: opts.sorts,
        search: opts.search,
      }

      if (filter?.orderBy && !filter.orderBy.length) delete filter.orderBy
      if (filter?.search && !filter.search) delete filter.search

      this.isBusy = true
      const res = await this.apiClient.get(filter)
      if (!res) return
      this.items = this.itemProperty ? res.data[this.itemProperty] : res.data

      if (this.hasDisabled) {
        let allIds = []
        this.items.map((item) => {
          if (!item.ssgroupId) {
            allIds.push(item[this.trackBy])
          }
        })
        this.ids = [...new Set(allIds)]
      } else {
        if (this.hasMassSelect && !opts.search) {
          const allFilter = {
            pagination: {
              page: 1,
              show: 9999,
            },
            orderBy: opts.sorts,
            search: opts.search,
          }
          const allRes = await this.apiClient.get(allFilter)
          this.ids = allRes.data.map((x) => x[this.trackBy])
        } else this.ids = this.items.map((x) => x[this.trackBy])
      }
      this.page = res.pagination.page
      this.totalCount = res.pagination.total

      if (this.items.length === 0 && !this.search) {
        this.$emit('available-change', false)
      }

      this.isBusy = false

      if (this.lazyLoadAddress) {
        await this.generateAddressReport()
      }

      if (this.hasGraph && refresh) {
        const data = await this.apiClient.getGraph()
        this.dataGraph = data
      }
    },

    handleSearchChange: debounce(async function (_search) {
      this.search = _search
      const opts = {
        limit: this.limit,
        search: _search != '' ? _search : undefined,
        page: 1,
        sorts: this.stringSorts(),
      }
      await this.getData(opts)
      this.$refs['search-input-ref'].$el.focus()
    }, 500),

    handleClearSearch() {
      this.handleSearchChange(undefined)
    },

    async handleLimitChange(_limit) {
      this.limit = _limit

      await this.getData({
        limit: _limit,
        search: this.search != '' ? this.search : undefined,
        page: 1,
        sorts: this.stringSorts(),
      })
    },

    async handlePageChange(newPage) {
      const opts = {
        page: newPage,
        search: this.search != '' ? this.search : undefined,
        limit: this.limit,
        sorts: this.stringSorts(),
      }
      await this.getData(opts)
    },

    async handleSortChange(data) {
      // If this function is called without data params,
      // remove sorting (revert to default)
      if (!data) {
        this.sorts = []
        return
      }

      // If field not sortable or If currently editing a field, disable sort
      if (!data?.field?.isSortable) return

      // Get index of current column sort, if any
      const currentColumnSortIndex = this.sorts.findIndex((sort) => sort.key === data.field.key)
      // Get the sorting data (key, order)
      const currentColumnSort = this.sorts[currentColumnSortIndex]
      let newSorts = [...this.sorts]
      // This switch case is used to toggle between these conditions:
      // default - asc - desc - default (repeat)
      switch (currentColumnSort?.order) {
        case 'asc':
          newSorts[currentColumnSortIndex] = {
            key: currentColumnSort.key,
            order: 'desc',
          }
          break

        case 'desc':
          newSorts.splice(currentColumnSortIndex, 1)
          break

        default:
          // If it have single sort, remove all other sorts
          if (this.singleSort) newSorts = []
          newSorts.push({ key: data.field.key, order: 'asc' })
          break
      }

      this.sorts = [...newSorts]

      await this.$nextTick()

      return this.getData({
        limit: this.limit,
        page: 1,
        search: this.search != '' ? this.search : undefined,
        sorts: this.stringSorts(),
      })
    },

    async handleDelete() {
      const _selected = Object.keys(this.selectedIds).filter((key) => this.selectedIds[key] == true)
      this.isBusy = true
      const promises = []

      if (this.bulkDeleteApi) {
        this.deleteBulk(_selected)
        return
      }

      if (!this.apiClient.delete) {
        this.$store.commit(this.hasStore.delete, _selected)
        this.handleUnselectAll()
        setTimeout(() => {
          this.getData({
            limit: this.limit,
            page: 1,
            sorts: this.stringSorts(),
          })
          this.$refs['mc-modal-delete'].hide()
        }, 300)
      } else {
        _selected.forEach((el) => {
          promises.push(this.apiClient.delete(el))
        })

        await Promise.all(promises).then((res) => {
          if (this.search) this.handleClearSearch()
          this.handleUnselectAll()
          setTimeout(() => {
            this.getData({
              limit: this.limit,
              page: 1,
              sorts: this.stringSorts(),
            })
            this.$refs['mc-modal-delete'].hide()
            res.forEach((result) => {
              if (result) this.$mcToast.success(this.$t('global.alert.text.delete'))
              else {
                if (this.customToast) {
                  this.customToast()
                } else {
                  this.$mcToast.error({
                    component: 'McToastDynamicBody',
                    props: {
                      contents: [
                        {
                          tag: 'h6',
                          text: this.$t('maintenance.alert.deleteFailed'),
                        },
                        {
                          tag: 'p',
                          text: this.$t('global.alert.text.failedDelete'),
                        },
                      ],
                    },
                  })
                }
              }
            })
          }, 300)
        })
      }
    },

    handleAdd() {
      if (this.customHandlers?.handleAdd) this.customHandlers.handleAdd()
    },

    handleSelect(checked, data) {
      if (this.checkType === 'single') {
        this.selectedIds = { [data.item[this.trackBy]]: true }
        this.selectedIdsLength = 1
      } else {
        this.selectedIds = { ...this.selectedIds, [data.item[this.trackBy]]: checked }
        if (this.customDelete) {
          this.selectedNames = { ...this.selectedNames, [data.item[this.displayDeleteBy]]: checked }
          for (const name in this.selectedNames) {
            if (this.selectedNames[name] === true) {
              this.selectedName = name
              break
            }
          }
        }

        if (checked) {
          if (this.hasDisabled) {
            let flag = true
            const selectedKeys = Object.keys(this.selectedIds).filter(
              (key) => this.selectedIds[key]
            )
            for (const iterator of this.ids) {
              let index = selectedKeys.indexOf(iterator.toString())
              if (index == -1) {
                flag = false
                break
              }
            }
            if (flag) this.selectedAll = true
            else this.selectedAll = false
          }
          this.selectedIdsLength += 1
        } else {
          if (this.hasDisabled) this.selectedAll = false
          this.selectedIdsLength -= 1
        }
      }
      this.$emit('totalSelected', this.selectedIdsLength)
      this.$emit('handleSelectValue', this.selectedIds)
    },

    handleSelectAll(event) {
      if (event) {
        this.selectedIds = Object.fromEntries(this.ids.map((key) => [key, true]))
        this.$emit('handleSelectValue', this.selectedIds)
        this.selectedIdsLength = this.ids.length
        this.selectedAll = true
      } else {
        this.handleUnselectAll()
      }
    },

    handleUnselectAll() {
      this.selectedIds = {}
      this.$emit('handleSelectValue', {})
      this.selectedAll = false
      this.selectedIdsLength = 0
    },

    handleClickRow(field, item) {
      if (field.isRedirectable && this.customHandlers?.handleClickRow)
        this.customHandlers.handleClickRow(item)
    },

    handleSetDataFields(fields) {
      this.dataFields = this.cloneFields(fields)
      this.dataColumns = this.cloneColumns(fields)
    },

    showSortIcon(data, order) {
      const currentColumnSort = this.sorts.find((sort) => sort.key === data.field.key)
      if (!currentColumnSort) {
        return true
      }

      return currentColumnSort.key === data.field.key && currentColumnSort.order === order
    },

    async deleteBulk(ids) {
      if (this.search) this.handleClearSearch()
      this.handleUnselectAll()
      this.$refs['mc-modal-delete'].hide()
      this.selectedNames = {}
      this.selectedName = null
      const res = await this.apiClient.delete(ids)
      const requestData = {
        limit: this.limit,
        page: 1,
        sorts: this.stringSorts(),
      }

      setTimeout(() => {
        if (res) {
          this.getData(requestData)
          this.$mcToast.success(this.$t('global.alert.text.delete'))
        } else {
          this.getData(requestData)
          this.$mcToast.error({
            component: 'McToastDynamicBody',
            props: {
              contents: [
                {
                  tag: 'h6',
                  text: this.$t('maintenance.alert.deleteFailed'),
                },
                {
                  tag: 'p',
                  text: this.$t('global.alert.text.failedDelete'),
                },
              ],
            },
          })
        }
      }, 300)
    },

    changeTable(bool) {
      this.isTable = bool
      this.$emit('handleTableChanged', bool)
    },
  },
}
</script>

<template>
  <!-- TECHDEBT: add functionality to provide filter, per-page, etc from props -->
  <div class="mc-table">
    <slot
      name="button-filter"
      v-if="hasFilter"
      :showDeleteModal="showDeleteModal"
      :isSelected="!!selectedIdsLength"
      :selectedIds="selectedIds"
    ></slot>
    <div class="clearfix mb-3">
      <div class="float-start d-flex">
        <slot name="title" />
      </div>

      <div class="float-end d-flex" v-if="!isEmpty || (isEmpty && search) || emptyButton">
        <slot name="button-header" v-if="selectedIdsLength || customButton"></slot>
        <McButton
          v-if="selectedIdsLength && hasDelete"
          @click="showDeleteModal"
          variant="secondary-red"
          :text="$t('global.delete')"
          icon="icon-outline_trash"
          class="mx-2 mb-2 ms-auto"
        />
        <McButton
          v-if="typeof customHandlers?.handleAdd !== 'undefined'"
          variant="primary"
          class="mb-2 ms-auto"
          :disabled="isBusy || busy"
          :text="$t('global.create')"
          icon="icon-fill_plus"
          @click="handleAdd"
        />
        <slot name="button-value-help" v-if="customButton"></slot>
      </div>
    </div>
    <div class="pb-3" v-if="filterBottom">
      <slot
        name="button-filter"
        :showDeleteModal="showDeleteModal"
        :isSelected="!!selectedIdsLength"
      ></slot>
    </div>

    <div :class="{ card: withCard, 'p-4': cardPadding }">
      <div :class="withCard ? 'card-body' : ''">
        <b-row v-if="!isEmpty || (isEmpty && search)">
          <slot name="tab-button"></slot>
        </b-row>
        <b-row>
          <b-col md="4" class="mc-row-check-wrapper" v-if="hasGraph">
            <b-button-group>
              <b-button
                @click="changeTable(true)"
                :variant="isTable ? 'primary' : 'outline-primary'"
                ><i class="mc-fa icon-outline_browser"></i> Table</b-button
              >
              <b-button
                @click="changeTable(false)"
                :variant="isTable ? 'outline-primary' : 'primary'"
                ><i class="mc-fa icon-fill_activity"></i> Grafik</b-button
              >
            </b-button-group>
          </b-col>
          <b-col md="4" class="mc-row-check-wrapper">
            <h6 class="mc-row-check mt-0" v-if="selectedIdsLength">
              <span class="badge btn-success">{{ selectedIdsLength }}</span>
              {{ $t('global.object.selectedRow') }}
              <a @click="handleUnselectAll" class="color-primary">{{
                $t('global.action.deselect')
              }}</a>
            </h6>
          </b-col>
          <b-col :md="hasGraph ? 4 : 8" class="flex-row-reverse mc-table-view-wrapper">
            <div class="mc-table-view d-flex flex-row-reverse">
              <b-input-group
                size="sm"
                class="mc-has-search"
                @click="focusSearch"
                v-if="(searchable && !isEmpty) || (isEmpty && search)"
              >
                <template #prepend>
                  <i class="ps-2 mc-icon icon-fill_search"></i>
                </template>
                <b-form-input
                  :placeholder="$t('global.search') + '...'"
                  :disabled="isBusy || busy"
                  :value="search"
                  @input="handleSearchChange"
                  ref="searchInput"
                />
                <template #append v-if="search">
                  <button
                    class="clear-search-btn"
                    :disabled="isBusy || busy"
                    @click="handleClearSearch"
                  >
                    <i class="pe-2 mc-icon icon-outline_close"></i>
                  </button>
                </template>
              </b-input-group>

              <slot
                name="viewManager"
                :handleSetDataFields="handleSetDataFields"
                :dataFields="dataFields"
                :initialFields="initialFields"
                :dataColumns="dataColumns"
                v-if="isTable"
              />

              <div v-if="isSelectableField">
                <p class="mc-label">{{ $t('global.action.show') }}</p>
                <multiselect
                  id="fieldColumnShow"
                  v-model="show_model"
                  :options="showedFields"
                  :multiple="true"
                  :placeholder="$t('global.object.allColumn')"
                  track-by="label"
                  label="label"
                  ref="show_model"
                />
              </div>
            </div>
          </b-col>
        </b-row>
        <div v-if="isLoading"></div>

        <div class="mt-4" v-if="!isTable && hasGraph">
          <slot name="graphic" :dataGraph="dataGraph" />
        </div>
        <div
          :class="classTable"
          v-if="((!isLoading && !isEmpty) || (isEmpty && search)) && isTable"
        >
          <b-table
            :sticky-header="stickyHeader"
            :busy="isBusy"
            :items="items"
            :fields="computedFields"
            :per-page="limit"
            fixed
            show-empty
            :class="{ 'b-table': true, 'table-bordered': hasBorder }"
          >
            <!-- Loading -->
            <template #table-busy>
              <div class="__busy">
                <b-spinner class="align-middle mb-2" />
                <strong>{{ $t('global.text.loading') }}...</strong>
              </div>
            </template>

            <!-- Empty Result -->
            <template #empty>
              <div class="text-center my-4">{{ $t('global.text.noData') }}</div>
            </template>

            <!-- Slot: Header Checkbox -->
            <template #head(checkbox) v-if="hasSelectAll && checkType === 'multiple'">
              <div class="form-check" style="width: 5px">
                <b-form-checkbox
                  @change="handleSelectAll"
                  v-model="selectedAll"
                  :disabled="isBusy || ids.length === 0 || busy"
                />
              </div>
            </template>

            <template #thead-top="data" v-if="childFields.length > 0">
              <tr>
                <template v-for="field in data.fields">
                  <th v-if="!field.hasOwnProperty('childOfIndex')" :key="field.key" :id="field.key">
                    <span class="sr-only"></span>
                  </th>
                  <th
                    style="text-align: center"
                    v-else-if="field.isTopHead"
                    id="sub-header"
                    :key="field.key"
                    :colspan="childFields[field.childOfIndex].headerColspan"
                  >
                    {{ childFields[field.childOfIndex].label }}
                  </th>
                </template>
              </tr>
            </template>

            <!-- Slot: Header Data -->
            <template #head()="data">
              <div @click="handleSortChange(data)">
                {{ data.label }}
                <template v-if="data.field.isSortable">
                  <div v-if="showSortIcon(data, 'asc')" class="sort-icon-up">
                    <i class="mc-icon icon-outline_chevron-up"></i>
                  </div>
                  <div v-if="showSortIcon(data, 'desc')" class="sort-icon-down">
                    <i class="mc-icon icon-outline_chevron-down"></i>
                  </div>
                </template>
              </div>
            </template>

            <!-- Slot: Cell Checkbox -->
            <template #cell(checkbox)="data">
              <div class="form-check">
                <input
                  v-if="checkType === 'single'"
                  type="radio"
                  class="custom-control-input"
                  :disabled="
                    isBusy || hasDisabled
                      ? customHandlers.handleDisabledRow(data.item)
                      : null || busy
                  "
                  name="radio-table"
                  :checked="selectedIds[data.item[trackBy]]"
                  @change="(event) => handleSelect(event, data)"
                />
                <b-form-checkbox
                  v-else
                  @change="(event) => handleSelect(event, data)"
                  :checked="selectedIds[data.item[trackBy]]"
                  :disabled="
                    isBusy || hasDisabled
                      ? customHandlers.handleDisabledRow(data.item)
                      : null || busy
                  "
                />
              </div>
            </template>

            <!-- Slot: Cells on first column -->
            <template
              #[`cell(${fields[0].key})`]="{ index, field, value, item }"
              v-if="fields[0].key != 'checkbox' && !fields[0].isObject"
            >
              <div
                :class="{
                  'fw-bold text-primary td__noellipsis': !field.isRedirectable ? false : true,
                  'clickable-field': field.isRedirectable,
                }"
                @click="handleClickRow(field, item)"
                :title="value"
              >
                {{ value }}
              </div>
            </template>

            <template
              #[`cell(${computedFields[1].key})`]="{ index, field, value, item }"
              v-if="hasCheckbox"
            >
              <div
                :class="{
                  'fw-bold text-primary td__noellipsis': !field.isRedirectable ? false : true,
                  'clickable-field': field.isRedirectable,
                }"
                @click="handleClickRow(field, item)"
                :title="value"
                v-if="field.isShortable"
              >
                {{
                  value.length > field.shortableLength
                    ? value.substring(0, field.shortableLength)
                    : value
                }}
                <i
                  v-if="value.length > field.shortableLength"
                  v-b-tooltip.hover
                  class="mc-fa icon-fill_more-horizontal"
                  :title="value"
                ></i>
              </div>
              <div
                :class="{
                  'fw-bold text-primary td__noellipsis': !field.isRedirectable ? false : true,
                  'clickable-field': field.isRedirectable,
                }"
                @click="handleClickRow(field, item)"
                :title="value"
                v-else
              >
                {{ value }}
              </div>
            </template>

            <!-- Slot: All Cells -->
            <template #cell()="{ index, field, value, item }">
              <template v-if="typeof value === 'number'">
                <div class="td__overflow-ellipsis" :title="value">
                  {{ value.toLocaleString() }}
                </div>
              </template>

              <template v-else>
                <div v-if="field.isShortable">
                  {{
                    value.length > field.shortableLength
                      ? value.substring(0, field.shortableLength)
                      : value
                  }}
                  <i
                    v-if="value.length > field.shortableLength"
                    v-b-tooltip.hover
                    class="mc-fa icon-fill_more-horizontal"
                    :title="value"
                  ></i>
                </div>
                <div v-else class="td__overflow-ellipsis" :title="value">
                  {{ value }}
                </div>
              </template>
            </template>

            <!-- Slot: Slot override from parent component -->
            <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">
              <slot :name="name" v-bind="data"></slot>
            </template>
          </b-table>
        </div>

        <div v-else-if="isLoading"></div>
        <div v-else-if="isEmpty && !search">
          <slot name="emptyState" />
        </div>
        <div class="d-flex flex-wrap flex-md-nowrap" v-if="showPagination && !isEmpty && isTable">
          <div class="mc-limit">
            <div class="__limit">
              {{ $t('global.text.displays') }}
              <b-form-select
                class="form-select form-select-sm __limit--dropdown"
                size="sm"
                :disabled="isBusy"
                :options="limitOptions"
                :value="limit"
                @input="handleLimitChange"
              />
              <div>{{ $t('global.text.data') }}</div>
            </div>

            <div class="__info">
              <strong>{{ startData }}</strong> - <strong>{{ endData }}</strong>
              {{ $t('global.object.of') }} <strong>{{ totalCount }}</strong>
              {{ $t('global.text.data') }}
            </div>
          </div>
          <div class="mc-pagination-container">
            <b-pagination
              :disabled="isBusy"
              :per-page="limit"
              :total-rows="totalCount"
              :value="page"
              @change="handlePageChange"
            />
          </div>
        </div>
      </div>
    </div>
    <b-modal
      class="mc-modal"
      id="mc-modal-delete"
      ref="mc-modal-delete"
      :title="$t('global.action.delete')"
      size="md"
      centered
      scrollable
    >
      <div class="card-body p-2" v-if="customDelete">
        <p v-if="selectedIdsLength === 1">
          {{ $t('global.confirmDelete') }} <strong class="bold">{{ selectedName }}</strong> ?
        </p>
        <p v-else>
          {{ $t('global.confirmDelete') }}
          <strong class="bold">{{ selectedIdsLength }} {{ $t('global.object.data') }}</strong>
          {{ $t('global.selected') }}?
        </p>
      </div>
      <div class="card-body p-2" v-else>
        <p>
          {{ $t('global.confirmDelete1') }} <strong>{{ selectedIdsLength }}</strong>
          {{ $t('global.confirmDelete2') }}
        </p>
      </div>
      <template #modal-footer="{ cancel }">
        <div class="d-flex">
          <McButton
            variant="secondary"
            :text="$t('global.action.cancel')"
            class="me-2"
            @click="cancel()"
          />
          <McButton variant="primary" :text="$t('global.action.delete')" @click="handleDelete" />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
@import './style.scss';
</style>
